import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/searchPage/actionTypes';

import { setDialogModels } from './utils';

export default function* listenSetDialogModels() {
  yield takeEvery(actionTypes.SET_DIALOG_MODELS, setDialogModels);
}
